import firebase from 'firebase';

const config = {
  apiKey: 'AIzaSyDjB3sp6PB72sUt83uvjzpTLRV-dlQ_q6M',
  authDomain: 'codingdrills.firebaseapp.com',
  databaseURL: 'https://codingdrills.firebaseio.com',
  storageBucket: 'codingdrills.appspot.com'
};

const fire = firebase.initializeApp(config);
export const googleAuth = new firebase.auth.GoogleAuthProvider();
export const auth = firebase.auth();
export const db = firebase.database();
export default fire;
